import Row from "../UI/Row";
import {
    FaArrowRight,
    FaChevronRight,
    FaEnvelopeSquare,
    FaMapMarkedAlt,
    FaMapMarkerAlt,
    FaPhoneSquare
} from "react-icons/fa";
import React from "react";

const Footer = () => {

    const personalDataClick = () => {
        window.location.href = process.env.REACT_APP_WEBSITE_DOMAIN + "/trattamento-dati-personali/";
    }

    const termsAndConditionClick = () => {
        window.location.href = process.env.REACT_APP_WEBSITE_DOMAIN + "/termini-e-condizioni/";
    }

    const creditsClick = () => {
        window.location.href = "https://www.net-evolution.com/";
    }

    return (
        <div>
            <div className="w-full h-1 bg-gray-600 ">



            </div>
            <div className="w-full min-h-32 bg-white flex flex-col items-center">
                <div className="w-full text-left flex flex-col md:flex-row gap-4 md:gap-1 p-4" style={{maxWidth: "1200px"}}>
                    <div className="flex-1 mb-4 md:mb-0">
                        <div className="mb-2 font-semibold text-lg">EDILIZIAPP srls</div>
                        <Row className="items-center gap-3 mb-2">
                            <FaMapMarkerAlt className="text-ea_green_from"/>
                            <div className="text-sm">
                                <div>Via salita ss Trinità 32/B</div>
                                <div>Montecchio Maggiore Vicenza</div>
                            </div>
                        </Row>
                        <Row className="items-center gap-3 mb-2">
                            <FaEnvelopeSquare className="text-ea_green_from" />
                            <div className="text-sm">info@ediliziapp.it</div>
                        </Row>
                        <Row className="items-center gap-3">
                            <FaChevronRight className="text-ea_green_from" />
                            <div className="text-sm">P.iva 04332530247</div>
                        </Row>
                    </div>

                    <div className="flex-1 mb-4 md:mb-0">
                        <div className="mb-2 font-semibold text-lg">ASSISTENZA TECNICA</div>
                        <Row className="gap-1 text-ea_green_from items-center">
                            <FaPhoneSquare />
                            <div className="font-bold text-xl">+39 375 67 61 341</div>
                        </Row>

                    </div>

                    <div className="flex-1 mb-4 md:mb-0">
                        <Row className="gap-1 items-center text-sm mb-3 cursor-pointer" onClick={personalDataClick}>
                            <FaArrowRight className="text-ea_green_from"/>
                            <div className="font-semibold text-xs">Trattamento dei dati personali</div>
                        </Row>
                        <Row className="gap-1 items-center text-sm cursor-pointer" onClick={termsAndConditionClick}>
                            <FaArrowRight className="text-ea_green_from"/>
                            <div className="font-semibold text-xs">Termini e condizioni</div>
                        </Row>

                        <div className="mt-12 text-xs cursor-pointer" onClick={creditsClick}>credits</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
